import React, { useState } from 'react';
import './Schedule.css';
import Header from '../components/header';
import Footer from '../components/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTwitter, faYoutube, faLine } from '@fortawesome/free-brands-svg-icons';
import { isMobile } from 'react-device-detect'; // デバイスタイプの検出

const events = [
  {
    type: '合同練習',
    date: '未定',
    time: '未定',
    place: '未定',
    songs: ['未定'],
  },
  {
    type: 'ミートアップ',
    date: '未定',
    time: '未定',
    place: '未定',
    url: '未定',
  }
  // {
  //   type: '合同練習',
  //   date: '2024年8月2日(土)',
  //   time: '14:00~17:00',
  //   place: '大阪センタービル8F',
  //   songs: ['幾億光年', '天国と地獄'],
  // },
  // {
  //   type: '合同練習',
  //   date: '2024年8月9日(土)',
  //   time: '14:00~17:00',
  //   place: '梅田ビル5F',
  //   songs: ['国歌'],
  // },
  // {
  //   type: 'ミートアップ',
  //   date: '2024年8月10日(土)',
  //   time: '14:00~17:00',
  //   place: 'Zoom',
  //   url: 'https://example',
  // },
  // {
  //   type: '合同練習',
  //   date: '2024年8月9日(土)',
  //   time: '14:00~17:00',
  //   place: '梅田ビル5F',
  //   songs: ['国歌'],
  // },
  // {
  //   type: 'ミートアップ',
  //   date: '2024年8月10日(土)',
  //   time: '14:00~17:00',
  //   place: 'Zoom',
  //   url: 'https://example',
  // },
];

const PCSchedule = () => {
  
    const [selectedType, setSelectedType] = useState('all');

    const handleButtonClick = (type) => {
      setSelectedType(type);
    };
  
    const filteredEvents = events.filter((event) => {
      if (selectedType === 'all') return true;
      return event.type === selectedType;
    });
  
    return (
      <div>
        <Header />
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <div className="container mx-auto p-1 mt-5">
          <h1 className="text-5xl font-bold uppercase mb-2">SCHDULE</h1>
          <br></br>
          <br></br>
          <div className="container mx-auto p-4 mt-4">
            <div className="button-container">
              <button
                onClick={() => handleButtonClick('all')}
                className={`button ${selectedType === 'all' ? 'active' : ''}`}
              >
                ALL
              </button>
              <button
                onClick={() => handleButtonClick('合同練習')}
                className={`button ${selectedType === '合同練習' ? 'active' : ''}`}
              >
                合同練習
              </button>
              <button
                onClick={() => handleButtonClick('ミートアップ')}
                className={`button ${selectedType === 'ミートアップ' ? 'active' : ''}`}
              >
                ミートアップ
              </button>
            </div>
            {filteredEvents.map((event, index) => (
              <div 
                key={index} 
                className={`bg-white shadow-md rounded p-6 mb-2 ${event.type === '合同練習' ? 'event-合同練習' : 'event-ミートアップ'}`}
              >
                <h2 className="text-xl font-bold mb-2">{event.type}</h2>
                <p className="mb-2 text-sm"><strong>日時:</strong> {event.date} {event.time}</p>
                <p className="mb-2 text-sm"><strong>場所:</strong> {event.place}</p>
                {event.url && (
                  <p className="mb-2"><strong>URL:</strong> <a href={event.url} className="text-blue-500">{event.url}</a></p>
                )}
                {event.songs && (
                  <p className="mb-2 text-sm"><strong>曲目:</strong> {event.songs.join(', ')}</p>
                )}
              </div>
            ))}
          </div>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <div className="flex justify-center mt-6">
          <a href="https://www.instagram.com/anoen2025/?utm_source=ig_embed&ig_rid=e42f20b4-19c3-432a-93bd-d224e592bd6b" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
            <a href="https://x.com/anoen2025?ref_src=twsrc%5Etfw%7Ctwcamp%5Eembeddedtimeline%7Ctwterm%5Escreen-name%3Aanoen2025%7Ctwcon%5Es1" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
              <FontAwesomeIcon icon={faTwitter} size="2x" />
            </a>
            <a href="https://www.youtube.com/@%E3%81%82%E3%81%AE%E6%BC%94" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
              <FontAwesomeIcon icon={faYoutube} size="2x" />
            </a>
        </div>
        <div className="text-center mt-20">
          <p className="text-black-400">Copyright © 2024 「あの演奏会をもう一度」運営 All Rights Reserved.</p>
        </div>
        <br></br>
        <br></br>
      </div>
    );
  }

  const MobileSchedule = () => {

    const [selectedType, setSelectedType] = useState('all');

    const handleButtonClick = (type) => {
      setSelectedType(type);
    };
  
    const filteredEvents = events.filter((event) => {
      if (selectedType === 'all') return true;
      return event.type === selectedType;
    });
  
    return (
      <div>
        <Header />
        <br></br>
        <br></br>
        <br></br>
        <div className="container mx-auto p-1 mt-5">
          <h1 className="text-3xl font-bold uppercase mb-2">SCHDULE</h1>
          <div className="container mx-auto p-2 mt-4">
            <div className="button-container">
              <button
                onClick={() => handleButtonClick('all')}
                className={`button ${selectedType === 'all' ? 'active' : ''}`}
              >
                ALL
              </button>
              <button
                onClick={() => handleButtonClick('合同練習')}
                className={`button ${selectedType === '合同練習' ? 'active' : ''}`}
              >
                合同練習
              </button>
              <button
                onClick={() => handleButtonClick('ミートアップ')}
                className={`button ${selectedType === 'ミートアップ' ? 'active' : ''}`}
              >
                ミートアップ
              </button>
            </div>
            {filteredEvents.map((event, index) => (
              <div 
                key={index} 
                className={`bg-white shadow-md rounded p-6 mb-2 ${event.type === '合同練習' ? 'event-合同練習' : 'event-ミートアップ'}`}
              >
                <h2 className="text-xl font-bold mb-2">{event.type}</h2>
                <p className="mb-2 text-sm"><strong>日時:</strong> {event.date} {event.time}</p>
                <p className="mb-2 text-sm"><strong>場所:</strong> {event.place}</p>
                {event.url && (
                  <p className="mb-2"><strong>URL:</strong> <a href={event.url} className="text-blue-500">{event.url}</a></p>
                )}
                {event.songs && (
                  <p className="mb-2 text-sm"><strong>曲目:</strong> {event.songs.join(', ')}</p>
                )}
              </div>
            ))}
          </div>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <div className="flex justify-center mt-6">
        <a href="https://www.instagram.com/anoen2025/?utm_source=ig_embed&ig_rid=e42f20b4-19c3-432a-93bd-d224e592bd6b" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faInstagram} size="2x" />
          </a>
          <a href="https://x.com/anoen2025?ref_src=twsrc%5Etfw%7Ctwcamp%5Eembeddedtimeline%7Ctwterm%5Escreen-name%3Aanoen2025%7Ctwcon%5Es1" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faTwitter} size="2x" />
          </a>
          <a href="https://www.youtube.com/@%E3%81%82%E3%81%AE%E6%BC%94" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white mx-7">
            <FontAwesomeIcon icon={faYoutube} size="2x" />
          </a>
        </div>
        <div className="text-center mt-20">
          <p className="text-black-400">Copyright © 2024 「あの演奏会をもう一度」運営 <br></br>All Rights Reserved.</p>
        </div>
        <br></br>
        <br></br>
      </div>
    );
  }

  function Schedule() {
    return isMobile ? <MobileSchedule /> : <PCSchedule />;
  }

  export default Schedule;

